export const snippetList = [
  {
    name: 'State',
    key: 'state',
    value: 'State',
  },
  {
    name: 'URL',
    key: 'url',
    value: 'URL',
  },
  {
    name: 'URL is not correct!',
    key: 'incorrect_url',
    value: 'URL is not correct!',
  },
  {
    name: 'URL is required!',
    key: 'url_is_required',
    value: 'URL is required!',
  },
  {
    name: 'URL is not valid!',
    key: 'url_is_not_valid',
    value: 'URL is not valid!',
  },
  {
    name: 'Back',
    key: 'back',
    value: 'Back',
  },
  {
    name: 'Edit configuration',
    key: 'edit_configuration',
    value: 'Edit configuration',
  },
  {
    name: 'Value',
    key: 'value',
    value: 'Value',
  },
  {
    name: 'Value is required!',
    key: 'value_is_required',
    value: 'Value is required!',
  },
  {
    name: 'Instances',
    key: 'instances',
    value: 'Instances',
  },
  {
    name: 'Cancel',
    key: 'cancel',
    value: 'Cancel',
  },
  {
    name: 'Save',
    key: 'save',
    value: 'Save',
  },
  {
    name: 'Upload',
    key: 'upload',
    value: 'Upload',
  },
  {
    name: 'Health',
    key: 'health',
    value: 'Health',
  },
  {
    name: 'The key has already been taken.',
    key: 'add_instance_error_message',
    value: 'The key has already been taken.',
  },
  {
    name: 'Delete Confirm message',
    key: 'delete_confirm_message',
    value: 'Are you sure you want to delete this item?',
  },
  {
    name: 'Activate Confirm message',
    key: 'activate_confirm_message',
    value: 'Are you sure you want to create a Real Instance?',
  },
  {
    name: 'Deactivate Confirm message',
    key: 'deactivate_confirm_message',
    value: 'Are you sure you want to deactivate the Real Instance?',
  },
  {
    name: 'Delete',
    key: 'delete',
    value: 'Delete',
  },
  {
    name: 'Activate',
    key: 'activate',
    value: 'Activate',
  },
  {
    name: 'Deactivate',
    key: 'deactivate',
    value: 'Deactivate',
  },
  {
    name: 'Edit Address',
    key: 'edit_detail',
    value: 'Edit Address',
  },
  {
    name: 'Search',
    key: 'search',
    value: 'Search',
  },
  {
    name: 'Name',
    key: 'name',
    value: 'Name',
  },
  {
    name: 'User',
    key: 'user',
    value: 'User',
  },
  {
    name: 'Key',
    key: 'key',
    value: 'Key',
  },
  {
    name: 'Id',
    key: 'id',
    value: 'Id',
  },
  {
    name: 'Actions',
    key: 'actions',
    value: 'Actions',
  },
  {
    name: 'Domain',
    key: 'domain',
    value: 'Domain',
  },
  {
    name: 'Server',
    key: 'server',
    value: 'Server',
  },
  {
    name: 'Type',
    key: 'type',
    value: 'Type',
  },
  {
    name: 'Created At',
    key: 'createDate',
    value: 'Created At',
  },
  {
    name: 'First Name',
    key: 'firstName',
    value: 'First Name',
  },
  {
    name: 'Last Name',
    key: 'lastName',
    value: 'Last Name',
  },
  {
    name: 'Phone Number',
    key: 'phoneNumber',
    value: 'Phone Number',
  },
  {
    name: 'Updated At',
    key: 'updateDate',
    value: 'Updated At',
  },
  {
    name: 'Add Address',
    key: 'add_detail',
    value: 'Add Address',
  },
  {
    name: 'Add Instance',
    key: 'add_instance',
    value: 'Add Instance',
  },
  {
    name: 'Edit Instance',
    key: 'edit_instance',
    value: 'Edit Instance',
  },
  {
    name: 'Incorrect values!',
    key: 'required',
    value: 'Incorrect values!',
  },
  {
    name: 'Domain is required',
    key: 'domain_is_required',
    value: 'Domain is required',
  },
  {
    name: 'Server is required',
    key: 'server_is_required',
    value: 'Server is required',
  },
  {
    name: 'User is required',
    key: 'user_is_required',
    value: 'User is required',
  },
  {
    name: 'Instance Type is required',
    key: 'instance_type_is_required',
    value: 'Instance Type is required',
  },
  {
    name: 'Name is required',
    key: 'name_is_required',
    value: 'Name is required',
  },
  {
    name: 'Key is required!',
    key: 'key_is_required',
    value: 'Key is required!'
  },
  {
    name: 'Configuration',
    key: 'configuration',
    value: 'Configuration',
  },
];
